import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dirIcon'
})
export class DirIconPipe implements PipeTransform {
    transform(expanded: boolean): string {
        return expanded ? 'chevron-down-outline' : 'chevron-forward-outline';
    }
}
